module.exports = __webpack_public_path__ + "884c60a7b6c3683c64d56d670819e974.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Step1-5-text.svg
// module id = 2667
// module chunks = 1